import type { DrawerState } from '../index';

export const setDrawer = (state: DrawerState, { payload }: { payload: DrawerState }) => {
  state.contentType = payload.contentType;
  state.isOpen = payload.isOpen;
  state.dataSchema = payload.dataSchema;
  state.agendaId = payload.agendaId;
  state.viewId = payload.viewId;
  state.tableId = payload.tableId;
  state.canSave = payload?.canSave ?? true;
  state.entity = payload?.entity ?? '';
  state.referencedFormItemsMap = payload.referencedFormItemsMap ?? {};
  state.type = payload.type;
};
